import { FC } from 'react'
import { RecruitListItem_CurrentUserFragment } from 'generated/graphql'
import { TOTAL_AD_SLOTS } from '@app.feature/ad/constants/constants'
import { RECRUIT_TYPE_TO_AD_CODE } from '@app.feature/ad/desktop/NoticeBanner/RecruitIntern/NoticeBannerRecruitInternStatus.desktop'
import useGetActivityListFromAdsByPlacementCode from '@app.feature/ad/hooks/useGetActivityListFromAdsByPlacementCode'
import RecruitListSkeleton from '@app.feature/recruitList/component/recruitListTable/component/RecruitListSkeleton'
import { ActivityTypeID } from 'constants/enums'
import NoticeBannerRecruitInternMobile from './NoticeBannerRecruitIntern.mobile'

interface IFProps {
  activityType: ActivityTypeID
  currentUser?: RecruitListItem_CurrentUserFragment | null
}

const NoticeBannerRecruitInternStatusMobile: FC<IFProps> = ({
  activityType,
  currentUser,
}) => {
  const { ads, loading, error } = useGetActivityListFromAdsByPlacementCode({
    adPlacementCode: RECRUIT_TYPE_TO_AD_CODE[activityType],
    activityTypeID: activityType,
  })

  if (loading) {
    return (
      <RecruitListSkeleton isMobile={true} skeletonCount={TOTAL_AD_SLOTS} />
    )
  }

  if (error || !ads?.length) {
    return null
  }

  return <NoticeBannerRecruitInternMobile ads={ads} currentUser={currentUser} />
}

export default NoticeBannerRecruitInternStatusMobile
